import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import Services from "@/pages/Services";
import CostEstimator from "@/pages/CostEstimator";
import BookConsultation from "@/pages/BookConsultation";
import Contact from "@/pages/Contact";
import AIAssistant from "@/pages/AIAssistant";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/estimator" element={<CostEstimator />} />
            <Route path="/book" element={<BookConsultation />} />
            <Route path="/assistant" element={<AIAssistant />} />
            <Route path="/contact" element={<Contact />} />
            {/* Private admin access — not linked from public navigation */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
